import { styled } from '../../Utilities';
import { DropdownBase } from './Dropdown.base';
import { getStyles } from './Dropdown.styles';
export var Dropdown = styled(DropdownBase, getStyles, undefined, {
    scope: 'Dropdown',
});
//# sourceMappingURL=Dropdown.js.map